import React, { ChangeEventHandler, useRef } from 'react';
import { InputBase } from '@mui/material';
import Icon from '../../muiComponents/Icon';
import '../../stylesheets/stylesComponents/searchbar.scss';
import LoadingPlaceholder from '../../muiComponents/LoadingPlaceholder';

interface SearchBarProps {
    placeholder?: string;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onClear?: () => void;
    onSearch?: () => void;
    value: string;
    disabled?: boolean;
}

const SearchBar = (props: SearchBarProps) => {
    const {
        placeholder,
        onChange,
        value,
        onClear,
        onSearch,
        disabled = false,
    } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onSearch) {
            onSearch();
        }
    };

    const handleClear = () => {
        onClear?.();
        inputRef.current?.focus();
    };

    return (
        <div className='searchbar__container'>
            <InputBase
                inputRef={inputRef}
                placeholder={placeholder}
                aria-label={placeholder || 'Search'}
                className='searchbar__input'
                onChange={onChange}
                onKeyDown={handleKeyDown}
                value={value}
                disabled={disabled}
            />
            <div className='flex flex-gap-10'>
                {value &&
                    onClear &&
                    (disabled ? (
                        <LoadingPlaceholder
                            variant='rounded'
                            width={20}
                            height={20}
                        />
                    ) : (
                        <Icon
                            iconName='Close'
                            onClick={handleClear}
                            style={{ color: '#727272', cursor: 'pointer' }}
                        />
                    ))}
                {disabled ? (
                    <LoadingPlaceholder
                        variant='rounded'
                        width={20}
                        height={20}
                    />
                ) : (
                    <Icon
                        iconName='Search'
                        style={{
                            color: onSearch ? '#727272' : '#ddd',
                            cursor: onSearch ? 'pointer' : 'default',
                        }}
                        onClick={onSearch}
                    />
                )}
            </div>
        </div>
    );
};

export default React.memo(SearchBar);
